<template>
  <div>
    <v-row justify="space-between" align="center">
      <v-col sm="12" md="4">
        <v-text-field
          v-model="filter.q"
          placeholder="Cari kode, nomor, pengirim atau perihal"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col sm="12" md="2">
        <datepicker
          v-model="filter.dates"
          range
          placeholder="Tanggal Masuk Surat"
          :shortcuts="datePickerShortcut"
          format="DD/MM/YYYY"
        />
      </v-col>
    </v-row>
    <v-tabs background-color="white" color="primary" v-model="filter.status">
      <v-tab> <v-icon left>mdi-email-outline</v-icon> Surat Masuk </v-tab>
      <v-tab>
        <v-icon left>mdi-email-check-outline</v-icon> Diterima Pimpinan
      </v-tab>
      <v-tab> <v-icon left>mdi-email-lock</v-icon> Diarsipkan </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <br />
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :sort-by.sync="filter.order_by"
      :sort-desc.sync="filter.sort_desc"
      :loading="loading"
      hide-default-footer
      class="table-row"
      @click:row="onViewSurat"
    >
      <template v-slot:[`item.tgl_masuk`]="{ item }">
        <div class="oflow">
          {{ item.tgl_masuk | date }}
        </div>
      </template>
      <template v-slot:[`item.klasifikasi.jenis`]="{ item }">
        <div class="oflow">
          {{ item.klasifikasi && item.klasifikasi.jenis ? item.klasifikasi.jenis : '-' }}
        </div>
      </template>
      <template v-slot:[`item.tgl_surat`]="{ item }">
        <div class="oflow">
          {{ item.tgl_surat | date }}
        </div>
      </template>
      <template v-slot:[`item.tujuan`]="{ item }">
        <div class="oflow">
          {{ getTujuan(item) }}
        </div>
      </template>
      <template v-slot:[`item.tembusan`]="{ item }">
        <div class="oflow">
          {{
            item.tembusan.length
              ? item.tembusan.map(tb => tb.name).join(', ')
              : '-'
          }}
        </div>
      </template>
      <template v-slot:[`item.note`]="{ item }" style="margin: 0 -5px;">
        <v-chip small color="info" outlined>
          #{{ item.jenis_surat.toLowerCase() }}
        </v-chip>
        <v-chip
          small
          :color="item.is_tembusan ? 'default' : 'success'"
          outlined
        >
          {{ item.is_tembusan ? 'Tembusan' : 'Asli' }}
        </v-chip>
        <v-tooltip bottom v-if="!item.lampiran">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="error">
              mdi-file-remove
            </v-icon>
          </template>
          <span>Arsip belum diupload</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <br />
    <v-pagination
      v-model="pagination.current_page"
      :length="pagination.last_page"
      :total-visible="7"
    ></v-pagination>
    <v-dialog
      v-model="viewDialogVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <view-surat
        ref="viewSurat"
        :id-jenis-form="1"
        :item="selectedItem"
        @close-view-form="viewDialogVisible = false"
        @approve="onApprove"
        @archive="onArchive"
        @restore="onRestore"
      />
    </v-dialog>
    <v-dialog
      v-model="approveDialogVisible"
      transition="dialog-bottom-transition"
      width="400px"
    >
      <v-card :loading="approving">
        <v-card-title>Sampaikan Surat ke Pimpinan?</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-switch
            v-model="approve.is_urgent"
            color="warning"
            label="Surat Segera"
          ></v-switch>
          <v-alert dense color="warning" text outlined v-if="approve.is_urgent">
            Pimpinan akan diingatkan secara berkala untuk melakukan disposisi
          </v-alert>
          <v-textarea
            label="Catatan"
            placeholder="Catatan yang berhubungan dengan surat"
            v-model="approve.note"
            prepend-icon="mdi-information-outline"
            rows="2"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="approveDialogVisible = false"
          >
            Batal
          </v-btn>
          <v-btn color="success" @click="approveSurat" text>
            <v-icon left>mdi-email-check-outline</v-icon>
            Sampaikan Surat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="archiveDialogVisible"
      transition="dialog-bottom-transition"
      width="400px"
    >
      <v-card :loading="archiving">
        <v-card-title>Yakin Arsipkan Surat?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert text dense color="warning" class="mt-6">
            Surat yang diarsipkan tidak akan disampaikan kepada pimpinan
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="archiveDialogVisible = false"
          >
            Batal
          </v-btn>
          <v-btn color="warning darken-1" @click="arsip" text>
            <v-icon left>mdi-email-lock</v-icon>
            Arsipkan Surat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="restoreDialogVisible"
      transition="dialog-bottom-transition"
      width="400px"
    >
      <v-card :loading="archiving">
        <v-card-title>Kembalikan Surat?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="restoreDialogVisible = false"
          >
            Tidak
          </v-btn>
          <v-btn color="warning darken-1" @click="restore" text>
            Ya
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  headerSuratMasuk,
  fetchSuratMasuk,
  arsipSuratPimpinan,
  approveSuratPimpinan,
  restoreSuratPimpinan
} from '@/services/surat'
import ViewSurat from './View'
import { debounce } from 'lodash'
import { monthNames } from '@/utils/common'
import { mapGetters } from 'vuex'
import { shortcut } from '@/utils/date-picker'
import moment from 'moment'

export default {
  name: 'surat-masuk-pimpinan-list',
  components: {
    'view-surat': ViewSurat
  },
  data() {
    return {
      viewDialogVisible: false,
      loading: false,
      headers: headerSuratMasuk.filter(header => header.value !== 'actions'),
      months: monthNames.map((month, index) => ({
        value: index + 1,
        text: month
      })),
      items: [],
      selectedItem: {
        formJenisSurat: { isEvent: false }
      },
      isEdit: false,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 0,
        from: 1
      },
      filter: {
        no_attachment: false,
        q: '',
        dates: [],
        order_by: ['index_surat'],
        sort_desc: [true],
        status: 0
      },
      deleteDialogVisible: false,
      deleteSurat: {},
      deleting: false,
      datePickerShortcut: shortcut,
      approveDialogVisible: false,
      approving: false,
      approve: {
        is_urgent: false,
        note: ''
      },
      archiveDialogVisible: false,
      archiving: false,
      restoreDialogVisible: false,
      restoring: false
    }
  },
  watch: {
    currentPage: function(val) {
      this.loadData(val)
    },
    filter: {
      handler: debounce(function() {
        this.loadData(1)
      }, 500),
      deep: true
    }
  },
  mounted() {
    this.loadData(1)
  },
  computed: {
    ...mapGetters(['hasPrivateAccess', 'isSuperAdmin']),
    currentPage() {
      return this.pagination.current_page
    }
  },
  methods: {
    onArchive() {
      this.archiveDialogVisible = true
    },
    onApprove() {
      this.approveDialogVisible = true
    },
    onRestore() {
      this.restoreDialogVisible = true
    },
    getTujuan(item) {
      let tujuan = item.tujuan.map(tj => tj.name)
      if (item.tujuan_lain) {
        tujuan.push(item.tujuan_lain)
      }
      if (tujuan.length) {
        return tujuan.join(', ')
      }
      return '-'
    },
    async loadData(page = this.pagination.current_page) {
      this.loading = true
      try {
        const {
          no_attachment,
          order_by,
          sort_desc,
          dates,
          status,
          ...filter
        } = this.filter

        let params = {
          ...filter,
          page,
          per_page: this.pagination.per_page
        }
        if (status === 1) {
          params.status = 'send'
        } else if (status === 2) {
          params.status = 'archive'
        }
        if (dates.length && dates[0]) {
          params.from = moment(dates[0]).format('YYYY-MM-DD')
          params.to = moment(dates[1]).format('YYYY-MM-DD')
        }
        if (order_by.length) {
          params.order_by = order_by[0]
        }
        if (sort_desc.length) {
          params.sort = sort_desc[0] ? 'desc' : 'asc'
        }
        if (no_attachment) {
          params.no_attachment = true
        }
        const { data, pagination } = await fetchSuratMasuk(params, true)
        this.items = data
        this.pagination = pagination
      } catch (error) {
        // console.log('load surat masuk error', error)
      } finally {
        this.loading = false
      }
    },
    getItemOrderNumber(item) {
      const index = this.items.findIndex(i => i.id === item.id)
      return this.pagination.from + index
    },
    onViewSurat(item) {
      if (!this.isEdit) {
        this.selectedItem = item
        this.viewDialogVisible = true
      }
      this.isEdit = false
    },
    async approveSurat() {
      try {
        this.approving = true
        await approveSuratPimpinan(this.selectedItem.id, this.approve)
        this.approveDialogVisible = false
        this.viewDialogVisible = false
        this.$emit(
          'handle-snackbar',
          'Surat telah disampaikan kepada pimpinan',
          'success'
        )
        this.loadData()
      } catch (error) {
        this.$emit(
          'handle-snackbar',
          'Gagal menyampaikan surat. Silahkan coba lagi',
          'error'
        )
      } finally {
        this.approving = false
      }
    },
    async arsip() {
      try {
        this.archiving = true
        await arsipSuratPimpinan(this.selectedItem.id)
        this.archiveDialogVisible = false
        this.viewDialogVisible = false
        this.$emit('handle-snackbar', 'Surat telah diarsipkan', 'success')
        this.loadData()
      } catch (error) {
        this.$emit(
          'handle-snackbar',
          'Gagal mengarsipkan surat. Silahkan coba lagi',
          'error'
        )
      } finally {
        this.archiving = false
      }
    },
    async restore() {
      try {
        this.restoring = true
        await restoreSuratPimpinan(this.selectedItem.id)
        this.restoreDialogVisible = false
        this.viewDialogVisible = false
        this.$emit('handle-snackbar', 'Surat telah dikembalikan', 'success')
        this.loadData()
      } catch (error) {
        this.$emit(
          'handle-snackbar',
          'Gagal mengembalikan surat. Silahkan coba lagi',
          'error'
        )
      } finally {
        this.restoring = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.row-column
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center

.v-chip
  margin-left: 5px
  margin-right: 5px

.bg-warning
  background-color: #FFECB3

.delete-table
  width: 100%
  margin-bottom: 20px
  th
    text-align: left

.mx-datepicker-range
  width: 100%
</style>

<style scoped>
.table-row >>> tbody tr :hover {
  cursor: pointer;
}
</style>
